export const STOREFRONT_LOGO_BASELINE_WIDTH_PX = 95
export const STOREFRONT_LOGO_BASELINE_HEIGHT_PX = 35
export const STOREFRONT_LOGO_WIDTH_DEFAULT_PX = STOREFRONT_LOGO_BASELINE_WIDTH_PX
export const STOREFRONT_LOGO_WIDTH_MIN_PX = 56
export const STOREFRONT_LOGO_WIDTH_MAX_PX = 140

const STOREFRONT_LOGO_HEIGHT_RATIO =
  STOREFRONT_LOGO_BASELINE_HEIGHT_PX / STOREFRONT_LOGO_BASELINE_WIDTH_PX

export const normalizeStorefrontLogoWidthPx = (
  value: unknown,
  fallback = STOREFRONT_LOGO_WIDTH_DEFAULT_PX
) => {
  const parsed =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim()
        ? Number.parseFloat(value)
        : Number.NaN

  if (!Number.isFinite(parsed)) return fallback

  return Math.min(
    STOREFRONT_LOGO_WIDTH_MAX_PX,
    Math.max(STOREFRONT_LOGO_WIDTH_MIN_PX, Math.round(parsed))
  )
}

export const getStorefrontLogoDimensions = (value: unknown) => {
  const width = normalizeStorefrontLogoWidthPx(value)
  const height = Math.max(1, Math.round(width * STOREFRONT_LOGO_HEIGHT_RATIO))

  return { width, height }
}
